var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"connection",class:_vm.position},[_c('svg',{attrs:{"viewBox":"0 0 100 5","xmlns":"http://www.w3.org/2000/svg"}},[_c('line',{attrs:{"x1":"0","x2":"100","stroke":"black"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }